export const REJECTION_REASON_CHIPS = [
  'Quality concerns',
  'Price exceeds budget',
  'Quantity not feasible',
  'Specifications do not match',
  'Delivery timeline unacceptable',
];

export const isActionableApprovalItem = (item) =>
  item?.itemStatus === 'pending';

export const getPendingApprovalItems = (items = []) =>
  (items || []).filter(isActionableApprovalItem);

export const hasAcceptedQuoteItems = (items = []) =>
  (items || []).some((item) => item?.itemStatus === 'accepted');

export const hasNegotiatedQuoteItems = (items = []) =>
  (items || []).some((item) => item?.itemStatus === 'negotiated');

export const hasSubmittedQuoteItems = (items = []) =>
  (items || []).some((item) => item?.itemStatus === 'submitted');

/** Items the buyer must resolve (accept/reject) before sending for approval. */
export const getBuyerReviewItems = (items = []) =>
  (items || []).filter((item) => item?.itemStatus && item.itemStatus !== '');

export const BUYER_RESOLVED_STATUSES = ['accepted', 'rejected', 'withdrawn'];

/**
 * Enable Request Approval only when every line is accepted, rejected, or withdrawn,
 * at least one is accepted, and none are submitted or negotiated.
 */
export const isRequestApprovalDisabled = (items = []) => {
  const list = getBuyerReviewItems(items);
  if (!list.length) return true;
  if (hasNegotiatedQuoteItems(list)) return true;
  if (hasSubmittedQuoteItems(list)) return true;
  if (!hasAcceptedQuoteItems(list)) return true;
  if (!list.every((item) => BUYER_RESOLVED_STATUSES.includes(item.itemStatus))) {
    return true;
  }
  return false;
};

export const buildRejectionReason = (selectedChips = [], customText = '') => {
  const chipPart = selectedChips.filter(Boolean).join('; ');
  const customPart = customText.trim();
  if (chipPart && customPart) return `${chipPart}. ${customPart}`;
  return chipPart || customPart;
};

export const isRejectionReasonValid = (selectedChips = [], customText = '') =>
  buildRejectionReason(selectedChips, customText).trim().length > 0;
